import { LogsImpressaoComponentProvider } from "@/components/LogsImpressaoComponent";

function LogsDeImpressao() {
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 px-4 lg:px-6">
      <LogsImpressaoComponentProvider />
    </div>
  );
}

export default LogsDeImpressao;
